<template>
  <router-link
    v-if="canShow"
    :key="rkey"
    v-ripple
    class="sidebar__link"
    @click.native="clickHandler"
    :tag="tag"
    :to="to"
  >
    <i :class="className" />
    <span>
      {{ title | globalize }}
    </span>
  </router-link>
</template>

<script>
export default {
  name: 'protected-router-link',
  props: {
    rkey: {
      type: String,
      required: true,
    },
    tag: {
      type: String,
      required: true,
      default: () => 'a',
    },
    to: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    clickHandler: {
      type: Function,
      required: true,
      default: () => {},
    },
    className: {
      type: String,
      required: true,
    },
    canShow: {
      type: Boolean,
      default: () => false,
    },
  },
}
</script>

<style lang="scss" scoped>
  @import '~@scss/variables';
  @import '~@scss/mixins';

  .sidebar__link-icon {
    margin-right: 1.6rem;
    color: $col-sidebar-text;
    font-size: 2.4rem;

    .router-link-active & {
      color: $col-sidebar-active-elem-text;
    }
  }
</style>
